'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _motionUi = require('motion-ui');

var _motionUi2 = _interopRequireDefault(_motionUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DOM = {};
var activePanel = '';
var initialErrorCode = 0;
var formSubmitted = false;

var __ = require('common/helpers/i18n').__;

var LoginUI = function () {
   function LoginUI() {
      _classCallCheck(this, LoginUI);
   }

   _createClass(LoginUI, null, [{
      key: 'init',
      value: function init() {
         DOM.username = $('#murdochUsername');
         DOM.usernamePanel = $('#mais-username-panel');
         DOM.usernameLabel = $('#mais-username-label');
         DOM.usernameError = $('#username-validation-msg');
         DOM.password = $('#murdochPassword');
         DOM.passwordPanel = $('#mais-password-panel');
         DOM.passwordError = $('#password-validation-msg');
         DOM.changeAccount = $('.change-account-msgs');
         initialErrorCode = parseInt($('#mais-error-code').data('code'));

         LoginUI.validation(true);
         $('.mais-change-username').on('click', function () {
            LoginUI.showUsernameForm();
         });
         $('#mais-login-form').on('submit', function () {
            if (!LoginUI.validation() || formSubmitted) return false;
            $('button[type="submit"]').attr("disabled", true);
            $('button[type="submit"] span.fa-spinner').show();
            formSubmitted = true;
            setTimeout(function () {
               // Hmmm. Timeout... User interrupted loading? Or really slow target?
               formSubmitted = false;
               $('button[type="submit"]').attr("disabled", false).removeAttr('disabled');
               $('button[type="submit"] span.fa-spinner').hide();
            }, 30000);
            return true;
         });
      }

      // Do Form Validation and auto-panel switching - skipping some Validation on Initial call

   }, {
      key: 'validation',
      value: function validation(first) {
         if (!first) {
            // Hide previous error message(s)
            DOM.usernameError.hide();
            DOM.passwordError.hide();
         }
         if (!LoginUI.checkUsername(first)) {
            LoginUI.showUsernameForm(first);
            return false;
         }

         // Always show Password Panel before submitting
         if (activePanel != 'password') {
            LoginUI.showPasswordForm(first);
            return false;
         }
         if (!LoginUI.checkPassword(first)) {
            return false;
         }
         return true;
      }
   }, {
      key: 'checkUsername',
      value: function checkUsername(first) {
         var username = DOM.username.val().trim() || '';

         var _ref = username.match(/^([0-9]{1,8}|S[0-9]{2}\w{5})\@(|student\.)murdoch\.edu\.au$/i) || [],
             _ref2 = _slicedToArray(_ref, 3),
             chkFormat = _ref2[0],
             userShort = _ref2[1],
             studentDomain = _ref2[2];

         var studentUsername = !!username.match(/^([013-9]\d{7,}|2[2789]\d{6,})(|@.*)$/);
         // console.log({username, chkFormat, userShort, studentUsername, studentDomain: !!studentDomain, isRight: studentUsername == !!studentDomain})
         if (!username || !chkFormat || studentUsername == !studentDomain) {
            if (!first) {
               if (studentUsername) DOM.usernameError.html(__('info:mais error invalid student'));else DOM.usernameError.html(__('info:mais error invalid'));
               DOM.usernameError.show();
            }
            return false;
         }
         // First access
         if (first) {
            // If it's the first load, and we don't have an existing session, stay on Username screen
            if (!DOM.changeAccount.data('username')) return false;
            // If it's the first load, and there's certain error codes, stay on Username screen. The error codes below are the NON-Username specific ones
            if (initialErrorCode && ![119, 131, 132, 136].includes(initialErrorCode)) return false;
         }

         return true;
      }
   }, {
      key: 'checkPassword',
      value: function checkPassword(first) {
         var password = DOM.password.val().trim();

         if (!password) {
            if (!first && activePanel == 'password') {
               DOM.passwordError.html(__('info:mais error 119'));
               DOM.passwordError.show();
               DOM.password.focus();
            }
            return false;
         } else {
            return true;
         }
      }
   }, {
      key: 'showUsernameForm',
      value: function showUsernameForm(first) {
         // console.log('Show Username Form')
         if (activePanel == 'username') return;
         activePanel = 'username';
         DOM.password.val('');
         if (first) {
            DOM.passwordPanel.hide();
            DOM.usernamePanel.show();
            DOM.username.focus();
            DOM.username.select();
            var unf = DOM.username[0];
            if (initialErrorCode == 120) {
               unf.selectionStart = unf.selectionEnd = unf.value.length;
            }
         } else {
            DOM.usernameError.hide();
            _motionUi2.default.animateOut(DOM.passwordPanel, 'slide-out-right fast', function () {
               _motionUi2.default.animateIn(DOM.usernamePanel, 'slide-in-left fast', function () {
                  DOM.username.focus();
                  DOM.username.select();
               });
            });
         }
      }
   }, {
      key: 'showPasswordForm',
      value: function showPasswordForm(first) {
         // console.log('Show Password Form')
         if (activePanel == 'password') return;
         activePanel = 'password';
         DOM.usernameLabel.html(DOM.username.val());
         if (DOM.changeAccount.length) {
            if (DOM.username.val() != DOM.changeAccount.data('username')) DOM.changeAccount.hide();else DOM.changeAccount.show();
         }
         if (first) {
            DOM.passwordPanel.show();
            DOM.usernamePanel.hide();
            DOM.password.focus();
         } else {
            DOM.passwordError.hide();
            _motionUi2.default.animateOut(DOM.usernamePanel, 'slide-out-left fast', function () {
               DOM.passwordError.hide();
               _motionUi2.default.animateIn(DOM.passwordPanel, 'slide-in-right fast', function () {
                  DOM.password.focus();
               });
            });
         }
      }
   }]);

   return LoginUI;
}();

module.exports = LoginUI;


//////////////////
// WEBPACK FOOTER
// ./client/js/login-ui.js
// module id = 134
// module chunks = 0